import React from 'react'
import {calcul} from './Utilitaire'

const FormatLine = ({ label, value, type, prefixe = '', suffixe = '' }) => (
    <p>{label} : <strong>{prefixe}{type === 'number' ? value.toLocaleString('fr') : value }{value === 0 ? '' : suffixe}</strong></p>
)

const Resultat = ({ situation, premierVst, versement_libre, periodicite, primeUnique, cotisation, duree, rendement, fraisVst, partUC , fraisGestion, valeurUC, rdtFondsGarantis }) => {
  
  const totalVstBrut = primeUnique === 'oui' ? versement_libre : cotisation * 12 * duree
  const totalVstNet = totalVstBrut * (1 - fraisVst)
  
  const datePremierVst = new Date(premierVst)  
  
  const datas = calcul(situation, periodicite, premierVst, primeUnique, versement_libre, cotisation, rendement, duree, 
        fraisVst, partUC , fraisGestion, valeurUC, rdtFondsGarantis)
        
  return (
    <div>
        <FormatLine
            label="Date"
            value={parseInt(datePremierVst.getFullYear() + duree)}
            prefixe="fin " />
        {(situation === 'favorable') && 
            <FormatLine 
                label="Total versements nets investis"
                value={totalVstNet}
                type="number"
                suffixe=" CFA" />}
        {(situation === 'favorable') && 
            <FormatLine
                label="Epargne atteinte par fonds garanti"
                value={datas.epargneFondsGarantis}
                type="number"
                suffixe=" CFA" />}
        {(situation === 'favorable') && 
            <FormatLine
                label="Epargne atteinte par UC"
                value={datas.epargneUC}
                suffixe=" CFA"
                type="number" />}
        {(situation === 'favorable') && 
            <FormatLine
                label="Epargne totale"
                value={datas.epargneFondsGarantis + datas.epargneUC}
                type="number"
                suffixe=" CFA" />}
        {(situation === 'favorable') && 
            <FormatLine
                label="Gain réalisé via Contrat ATLANTIQUE PLATINIUM"
                value={datas.epargneFondsGarantis + datas.epargneUC - totalVstNet}
                suffixe=" CFA"
                type="number" />}
        {(situation === 'favorable') && 
            <FormatLine
                label="Gain réalisé si Contrat Classique"
                value={datas.epargneClassique - totalVstNet}
                type="number"
                suffixe=" CFA" />}
        {(situation === 'defavorable') && 
            <FormatLine
                label="Epargne totale atteinte"
                value={datas.epargneTotaleAtteinte}
                type="number"
                suffixe=" CFA" />}
        {(situation === 'defavorable') && 
            <FormatLine
                label="Gain réalisé"
                value={datas.gainRealise}
                type="number"
                suffixe=" CFA" />}
    </div>
  )
}

export default Resultat